/** @file Mantine component default props and style overrides. */
import { radius } from './radius';
import { shadows } from './shadows';
import { layout } from './layout';

// Every dialog's X is a full touch target (WCAG 2.5.8; Mantine draws it at 28px).
const CLOSE_TARGET = {
  close: { width: layout.touchTarget, height: layout.touchTarget, minWidth: layout.touchTarget, minHeight: layout.touchTarget }
};

export const components = {
  Button: {
    defaultProps: {
      variant: 'outline',
      radius: radius.control
    },
    styles: {
      root: {
        boxShadow: 'none'
      }
    }
  },
  Card: {
    defaultProps: {
      radius: radius.surface,
      shadow: shadows.card,
      padding: 'lg'
    }
  },
  Modal: {
    defaultProps: {
      radius: radius.surface,
      shadow: shadows.modal
    },
    styles: CLOSE_TARGET
  },
  Paper: {
    defaultProps: {
      radius: radius.surface,
      shadow: shadows.flat
    }
  },
  Drawer: {
    defaultProps: {
      padding: 'md'
    },
    styles: CLOSE_TARGET
  },
  Tooltip: {
    defaultProps: {
      // Show on tap for touch devices, not only on hover.
      events: { hover: true, focus: true, touch: true }
    }
  },
  ActionIcon: {
    defaultProps: {
      variant: 'subtle'
    }
  },
  TextInput: {
    defaultProps: {
      radius: radius.control
    }
  },
  Notification: {
    defaultProps: {
      radius: radius.control
    }
  }
};
